module.exports = __webpack_public_path__ + "static/media/serio-homeHero.01f70d88.png";